export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00996.654cc80e.png";